import { Form } from 'antd';
import styled from 'styled-components';
import BillSelections from '../BillSelections';
import CustomerSearchInput, { ISearchCustomer } from '../Customer/SearchCustomer';
import TicketFooter from './TicketFooter';
import TicketTop from './TicketTop';
import LoyaltyCustomer from '../Customer/LoyaltyCustomer';

const CashierTicketInfo = () => {
  return (
    <Container>
      <TicketTop />
      <Form.Item shouldUpdate noStyle >
        {({ setFieldsValue, getFieldValue }) => {
          const customerName = getFieldValue('customerName');
          const customerId = getFieldValue('customerId');
          const customerPhone = getFieldValue('customerPhone');
          const customerPoint = getFieldValue('customerPoint');
          const value: ISearchCustomer = { customerName, customerId, customerPhone, customerPoint };
          return <CustomerSearchInput value={value} onChange={setFieldsValue} />;
        }}
      </Form.Item>
      <BillSelections />
      <Form.Item name={'membership'} noStyle>
        <LoyaltyCustomer />
      </Form.Item>
      <TicketFooter />
    </Container>
  );
};

export default CashierTicketInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #F6F7FC;
  box-shadow: -4px 0px 8px 0px rgba(0, 0, 0, 0.25);
`;
